import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class UsageService extends RLBaseService {
    static $inject = ["$resource", "$q"];

    constructor(private $resource: ng.resource.IResourceService, private $q: ng.IQService) {
        super($resource);
    }

    getUsages(entityID: string, page: number = 1, rowCount: number = 10, filters?: { [solrLabel: string]: string | string[] }, sortField?: string, sortDir?: number, catalogItemKeywords?: string) {
        return this.toRLService<Models.IUsageTableCollection>("/api/Usage/GetUsages").post(
            {
                parentEntityID: entityID,
                filters: filters,
                sortField: sortField,
                sortDir: sortDir,
                page: page,
                rowCount: rowCount,
                catalogItemKeywords: catalogItemKeywords
            }).$promise;
    }

    getBulkUsages(usageRelRecIDs: _.Dictionary<number>) {
        return this.toRLService<Models.IUsageRelationshipPair>("/api/Usage/GetBulkUsages").postArray(usageRelRecIDs).$promise;
    }

    getUsage(recID: number, relRecID: number) {
        return this.toRLService<Models.IUsageRelationshipPair>("/api/Usage/GetUsage").get({ recID: recID, relRecID: relRecID }).$promise;
    }

    getUsagesForEntity(entityID: string) {
        var data = {
            parentEntityID: entityID
        };

        return this.toRLService<Models.PagedEntities<Models.IUsageRelationshipPair>>("/api/Usage/GetUsagesForEntity").post(data).$promise;
    }

    getUsagesByIDs(parentEntityID: string, entityIDs: string[]) {
        var data = {
            parentEntityID: parentEntityID,
            entityIDs: entityIDs
        };

        return this.toRLService<Models.IUsageRelationshipPair>("/api/Usage/GetUsagesByIds").postArray(data).$promise;
    }

    deleteUsage(entityID: string) {
        var data = {
            entityID: entityID
        };

        return this.toRLService<boolean>("/api/Usage/DeleteUsage").delete(data).$promise;
    }

    bulkDeleteUsages(parentEntityID: string, usageIDs: number[]) {
        var data = {
            parentEntityID: parentEntityID,
            usageIDs: usageIDs
        };
        return this.toRLService<Models.IJobResponse>("/api/Usage/BulkDeleteUsages").delete(data).$promise;
    }

    deleteAmount(entityID: string) {
        var data = {
            amountEntityID: entityID
        };
        return this.toRLService<Models.IDataResponse<boolean>>("/api/Usage/DeleteAmount").post(data).$promise;
    }

    getUsageTemplates(entityID: string) {
        var data = {
            entityID: entityID
        }

        return this.toRLService<{ [templateID: number]: Models.ICharDataCollection }>("/api/Usage/GetUsageTemplates").get(data).$promise;
    }

    exportUsagesCSV(parentEntityID: string, usageTemplateID: number, filters?: { [solrLabel: string]: string | string[] }) {
        var data = {
            parentEntityID: parentEntityID,
            usageTemplateID: usageTemplateID,
            filters: filters
        };
        return this.toRLService<Models.IJobResponse>("/api/usage/exportusagescsv").post(data).$promise;
    }

    deleteOrphanedCatalogItems(orderedCatalogIDList: string[], entityID: string) {
        var data = {
            catalogIDList: orderedCatalogIDList,
            entityID: entityID
        };
        return this.toRLService<void>("/api/usage/deleteorphanedcatalogitems").post(data).$promise;
    }

    getAssociableInvoices(entityID: string, amountTemplateIDs: number[], currencyCharValueID: number) {
        var data: Models.IGetAssociableInvoicesEntityRequest = {
            entityID: entityID,
            amountTemplateIDs: amountTemplateIDs,
            currencyCharValueID: currencyCharValueID
        };
        return this.toRLService<Models.IAssociableInvoiceResults>("/api/usage/getassociableinvoices").post(data).$promise;
    }

    associateAmountsToInvoice(invoiceID: number, amountIDs: number[]) {
        var data: Models.IAssociateAmountsToInvoiceRequest = {
            invoiceID: invoiceID,
            amountIDs: amountIDs
        };
        return this.toRLService<void>("/api/usage/associateamountstoinvoice").post(data).$promise;
    }

    associateAmountsToNewInvoice(entityID: string, invoiceTemplateID: number, amountIDs: number[]) {
        var data: Models.IAssociateAmountsToNewEntityInvoiceRequest = {
            entityID: entityID,
            invoiceTemplateID: invoiceTemplateID,
            amountIDs: amountIDs
        };
        return this.toRLService<Models.ICreateEntityResponse>("/api/usage/associateamountstonewinvoice").post(data).$promise;
    }

    bulkCreateAmounts(parentRelRecIDs: number[], amountTemplateID: string, numberOfRows: number, perCatalogChecked: boolean, splitMethod: number, splitValues: { [index: number]: string },
        dueDateMethod: number, timeSpan: string, startDate: string, dueDates: { [index: number]: string }, copyTableValuesToAmounts: boolean) {
        var data: Models.IBulkCreateAmountsRequest = {
            parentRelRecIDs: parentRelRecIDs,
            amountTemplateID: amountTemplateID,
            numberOfRows: numberOfRows,
            perCatalogChecked: perCatalogChecked,
            splitMethod: splitMethod,
            splitValues: splitValues,
            dueDateMethod: dueDateMethod,
            timeSpan: timeSpan,
            startDate: startDate,
            dueDates: dueDates,
            copyTableValuesToAmounts: copyTableValuesToAmounts
        }

        return this.toRLService<Models.IJobResponse>("/api/Usage/BulkCreateAmounts").post(data).$promise;
    }

    getUsageAmountDocuments(parentEntityId: string, relEntityID: string, page: number, rowCount: number) {
        var data: Models.IGetUsageAmountDocumentsRequest = {
            parentEntityID: parentEntityId,
            relEntityID: relEntityID,
            page: page,
            pageSize: rowCount
        };

        return this.toRLService<Models.IUsageAmountDocumentResults>("/api/usage/getUsageAmountDocuments").post(data).$promise;
    }

    getEmptyEntityCharData(templateID: string) {
        return this.toRLService<Models.ICharDataCollection>("/api/usage/getemptyentitychardata").get({ templateID: templateID }).$promise;
    }

    copyToOrMoveToUsages(sourceEntityID: string, childCharTypeID: number, childRecIDs: number[], destinationEntityID: string, action:number) {
        var data = {
            sourceEntityID: sourceEntityID,
            childCharTypeID: childCharTypeID,
            childRecIDs: childRecIDs,
            destinationEntityID: destinationEntityID,
            action: action
        };
        return this.toRLService<Models.IJobResponse>("/api/usage/copyToOrMoveToUsages").post(data).$promise;
    }

    getTablesWithAmountWithAccountingDocuments(charTypeID: number, recordID: number, childCharTypeID: number, childRecordIDs: number[]) {
        var data = {
            charTypeID: charTypeID,
            recordID: recordID,
            childCharTypeID: childCharTypeID,
            childRecordIDs: childRecordIDs
        };

        return this.toRLService<Models.IDataResponse<Models.IEntityID[]>>("/api/usage/getTablesWithAmountWithAccountingDocuments").post(data).$promise;
    }

}
